export const DEV_PATH = "/dev"
export const AUTH_LOCAL_STORAGE_KEY = "auth_data"
export const AUTH_SEARCH_PARAMS_KEY = "authentication"
export const DELAY = 50
